import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { Clock, Gauge, Lightbulb } from 'lucide-react';

const AISection = () => {
  const { t } = useTranslation();

  return (
    <section id="ai-revolution" className="py-8 md:py-12 bg-gradient-to-br from-indigo-900 via-purple-900 to-blue-900 text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center">
            {/* Text-Inhalt */}
            <div className="w-full">
              <div className="mb-3">
                <h2 className="text-xl md:text-2xl font-bold text-white">
                  {t('businessAppsPage.service.ai.title')}
                </h2>
              </div>
              
              <p className="text-sm text-blue-100 mb-6 leading-relaxed">
                {t('businessAppsPage.service.ai.description')}
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                <div className="bg-blue-800/40 backdrop-blur-sm p-4 rounded-lg border border-blue-700">
                  <h3 className="font-semibold text-blue-300 mb-2 flex items-center justify-center text-sm">
                    <Clock className="h-4 w-4 mr-2" /> 
                    {t('businessAppsPage.service.ai.benefits.speed.title')}
                  </h3>
                  <p className="text-blue-100 text-sm">
                    {t('businessAppsPage.service.ai.benefits.speed.description')}
                  </p>
                </div>
                
                <div className="bg-blue-800/40 backdrop-blur-sm p-4 rounded-lg border border-blue-700">
                  <h3 className="font-semibold text-blue-300 mb-2 flex items-center justify-center text-sm">
                    <Gauge className="h-4 w-4 mr-2" /> 
                    {t('businessAppsPage.service.ai.benefits.quality.title')}
                  </h3>
                  <p className="text-blue-100 text-sm">
                    {t('businessAppsPage.service.ai.benefits.quality.description')}
                  </p>
                </div>
                
                <div className="bg-blue-800/40 backdrop-blur-sm p-4 rounded-lg border border-blue-700">
                  <h3 className="font-semibold text-blue-300 mb-2 flex items-center justify-center text-sm">
                    <Lightbulb className="h-4 w-4 mr-2" /> 
                    {t('businessAppsPage.service.ai.benefits.cost.title')}
                  </h3>
                  <p className="text-blue-100 text-sm">
                    {t('businessAppsPage.service.ai.benefits.cost.description')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AISection; 